import React from 'react';
import styles from './HandlerRegistry.module.scss';
import { HandlerRegistryHandler } from './types';

interface HandlerRegistryCardProps {
    handler: HandlerRegistryHandler;
    isOnboarded: boolean;
    onOnboard?: () => void;
}

const HandlerRegistryCard: React.FC<HandlerRegistryCardProps> = ({ handler, isOnboarded, onOnboard }) => (
    <div className={styles.card}>
        <div className={styles.cardIcon}>{handler.iconLabel}</div>
        <div className={styles.cardBody}>
            <div className={styles.cardTitleRow}>
                <span className={styles.cardName}>{handler.name}</span>
                <span className={styles.cardTag}>{handler.tag}</span>
                <span className={styles.cardVersion}>{handler.version}</span>
            </div>
            <div className={styles.cardSubtitle}>{handler.description}</div>
        </div>
        {isOnboarded ? (
            <span className={styles.onboardedPill}>ONBOARDED</span>
        ) : (
            <button type="button" className={styles.onboardButton} onClick={onOnboard}>
                ONBOARD
            </button>
        )}
    </div>
);

export default HandlerRegistryCard;
